import { render, staticRenderFns } from "./BusCommonMessageAccountCmModal.vue?vue&type=template&id=856102cc&"
import script from "./BusCommonMessageAccountCmModal.vue?vue&type=script&lang=js&"
export * from "./BusCommonMessageAccountCmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports